import { produce } from 'immer'
import { get, has, set } from 'lodash-es'
import { Subscribable } from './subscribable'

export type CacheArgs =
	| {
			initialValues?: object
	  }
	| undefined

export class Cache extends Subscribable {
	private raw: object
	private processedValues = new Map<string, unknown>()

	constructor({ initialValues }: CacheArgs = {}) {
		super()

		this.raw = initialValues ?? {}

		window.__config__ = window.__config__ || []
		window.__config__.push(this)
	}

	has = (key: string) => {
		return this.processedValues.has(key)
	}

	hasRaw = (key: string) => {
		return has(this.raw, key)
	}

	get = (key: string) => {
		return this.processedValues.get(key)
	}

	getRaw = (key: string) => {
		return get(this.raw, key)
	}

	updateRaw = (rawPart: object) => {
		this.raw = produce(this.raw, (draft) => {
			Object.entries(rawPart ?? {}).forEach(([key, value]) => {
				set(draft, key, value)
			})
		})
	}

	set = (key: string, value: unknown) => {
		this.processedValues.set(key, value)

		this.publish(key, value)
	}

	onSubscribe(key: string) {
		if (this.has(key)) {
			this.publish(key, this.get(key))
		}
	}
}
